import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Cookie } from "lucide-react";

const KEY = "rj_cookie_consent";
export const getCookieConsent = () => {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
};

export const CookieConsent = () => {
  const { t } = useTranslation();
  const [choice, setChoice] = useState("pending");

  useEffect(() => { setChoice(getCookieConsent() || "pending"); }, []);

  const decide = (val) => {
    try { localStorage.setItem(KEY, val); } catch (e) { /* noop */ }
    setChoice(val);
    // Let ads/analytics react to the new consent without a manual reload.
    window.dispatchEvent(new Event("rj-consent-changed"));
  };

  if (choice !== "pending") return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto bg-white border border-stone-border shadow-xl rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-brand-soft flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 text-brand" />
        </div>
        <p className="text-sm text-stone-sub flex-1 leading-relaxed">
          {t("cookie.text")}{" "}
          <Link to="/privacy" className="text-brand font-semibold hover:underline">{t("cookie.learnMore")}</Link>
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button data-testid="cookie-reject" onClick={() => decide("rejected")} className="flex-1 sm:flex-none px-4 py-2.5 rounded-xl border border-stone-border font-semibold text-stone-sub hover:border-brand hover:text-brand transition-colors">
            {t("cookie.reject")}
          </button>
          <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="flex-1 sm:flex-none px-5 py-2.5 rounded-xl bg-brand text-white font-semibold hover:bg-brand-hover transition-colors">
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
